import { PageDefaultSegment } from "@sis/react-library";
import { PageContainer } from "../../shared/PageContainer"
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { AdminFunctionsResaveAllTracksButton } from "../adminFunctionsResaveAllTracks/AdminFunctionsResaveAllTracksButton";
import { useState } from "react";
import { Box } from "@mui/material";
import { AdminFunctionsResaveAllTracksArea } from "../adminFunctionsResaveAllTracks/AdminFunctionsResaveAllTracksArea";

export interface AdminFunctionsPageAreaProps {
    onClose: () => void;
}

export const AdminFunctionsPage = () => {
    enum functionTypes {
        none,
        resaveAllTracks
    }

    const [currentFunction, setCurrentFunction] = useState(functionTypes.none);

    const resetCurrentFunction = () => {
        setCurrentFunction(functionTypes.none);
    }

    return (
        <PageContainer
            heading='Admin Functions'
            icon={<AdminPanelSettingsIcon />}
        >
            <PageDefaultSegment>
                <AdminFunctionsResaveAllTracksButton
                    busy={currentFunction !== functionTypes.none}
                    onClick={() => setCurrentFunction(functionTypes.resaveAllTracks)}
                />
            </PageDefaultSegment>
            {currentFunction !== functionTypes.none &&
                <Box sx={{ paddingTop: 2 }}>
                    {currentFunction == functionTypes.resaveAllTracks &&
                        <AdminFunctionsResaveAllTracksArea onClose={resetCurrentFunction} />
                    }
                </Box>
            }
        </PageContainer>
    )
}
